import React, { Component } from 'react';
import { Row,FormGroup,FormControl } from 'react-bootstrap';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import Logo from '../../Helper/Logo/logo';
import Back from "../../Helper/Back/back";
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { registerAction } from '../../Actions';
import {routeName} from '../../Service/env';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import axiosI from '../../Service/service';
import * as constants from '../../Constants';

const styles={
    Button: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none'
    },
    disabledButton: {
        color: '#fff',
        borderRadius: '5px',
        fontSize:'medium',
        marginBottom:'3%',
        textTransform:'none',
        opacity:0.6,
        '&:hover':{
            backgroundColor:'#851679',
            opacity:0.6,
            cursor:'auto'
        }
    },
};

class BusinessSection extends Component {
    constructor(props){
        super(props);
        this.state={
            address:'',
            lblLocationErrorMsg:'',
            lblCodeErrorMsg:'',
            data:{},
            addressFlag: false
        }
    }

    componentWillMount() {
        if (this.props.data) {
            const {data} = this.props;
            if (Object.keys(data).length > 0) {
                this.setState({ data })
            }
        }
    }

    handleChange = (value,text) => {
        let { data, addressFlag } = this.state;
        let lblErrorMsg= '';
        data[text ? text : 'address'] = value;
        if(!text) {
            !addressFlag && (addressFlag = value.length >= 1);
        }
        this.setState({ data, lblErrorMsg, addressFlag });
    };

    handleSelect = address => {
        let { data } = this.state;
        let addressFlag
        data['BusinessName']=address.substring(0, address.indexOf(','));
        if(address.length > 60) {
            address= address.substring(0, 60) + " ...";
        }
        data['address']=address;
        addressFlag = false;
        this.setState({ data, addressFlag });
        geocodeByAddress(address)
            .then(results => {
                data['PlaceID']=results[0].place_id;
                data['Address']=results[0].formatted_address;
                data['Address_Type']=results[0].types.join();
                getLatLng(results[0]).then(latLng => {
                    data['Address_Lat']=latLng.lat.toFixed(5);
                    data['Address_Long']=latLng.lng.toFixed(5);
                })
                this.doesBusinessExit(data['PlaceID']);
            })
            .catch(error => console.error('Error', error));
    };

    doesBusinessExit = (dialog_id) => {
        let data = {
            PlaceId:dialog_id
        };
        axiosI.post(constants.API.verifyBusinessExistApi,data).then((response)=>{
            if(response.data.results.ResponseCode) {
                this.setState({ lblLocationErrorMsg : '' });
            }
            else {
                this.setState({ lblLocationErrorMsg : 'A profile with that business name already exists!' });
            }
        }).catch((err)=>{
            this.setState({ lblLocationErrorMsg : 'Something went wrong while checking the address. Please select again.' });
            console.log(err);
        })
    };

    checkAPIs = () => {
        const { user } = this.props;
        if(this.state.data['PlaceID'] && !this.state.addressFlag) {
            let placeData = {
                PlaceId:this.state.data['PlaceID']
            };
            axiosI.post(constants.API.verifyBusinessExistApi,placeData).then((response)=>{
                if(response.data.results.ResponseCode) {
                    if(user.results.AppUser!==null && user.results.BusinessUser===null) {
                        this.props.registerAction({...this.state.data,
                            AppUserID:user.results.AppUser.UserId,
                            Username:user.results.AppUser.UserName,
                            Password:"",
                            PhoneNo:user.results.AppUser.PhoneNo
                        }).then((data)=>{
                            this.props.history.push({pathname:`/${routeName}/Payment`,state:{Business:data,withTrial:true}});
                        });
                    }
                    else {
                        this.props.next({...this.state.data,AppUserID:null});
                    }
                }
                else {
                    this.setState({ lblLocationErrorMsg : 'A profile with that business name already exists!' });
                }
            }).catch((err)=>{
                this.setState({ lblLocationErrorMsg : 'Something went wrong while checking the address. Please select again.' });
                console.log(err);
            })
        }
        else {
            this.setState({ lblLocationErrorMsg : 'Please enter valid address!' });
        }
    };

    checkEmpty=()=>{
        let {data} = this.state;

        if(!data.address) {
            this.setState({
                lblLocationErrorMsg:'Enter proper Address.'
            });
            return false;
        } else if(data.PlaceID === undefined) {
            this.setState({
                lblLocationErrorMsg:'Enter proper Address.'
            });
        }
        else {
            this.checkAPIs(data.verificationCode);
        }
    };

    onNext=()=>{
        this.checkEmpty();
    };

    onPrevious=()=>{
        this.props.onPrevious(this.state.data);
    };

    render(){
        const { classes } = this.props;

        const { lblCodeErrorMsg,lblLocationErrorMsg,data } = this.state;
        return(
            <section className="container">
                <Row>
                    <div className="col-12 text-center">
                        <Back onPrevious={this.onPrevious}/>
                        <Logo/>
                    </div>
                    <div className="col-12">
                        <h2 className='subHeading'>Business Name</h2>
                        <div className="error">
                            {
                                (lblLocationErrorMsg!=='')?
                                    <span>{lblLocationErrorMsg}</span>
                                    :(lblCodeErrorMsg!=='') ?
                                    <span>{lblCodeErrorMsg}</span>:<React.Fragment />
                            }
                        </div>
                        <FormGroup>
                            <PlacesAutocomplete
                                value={data.address}
                                onChange={this.handleChange}
                                onSelect={this.handleSelect}
                            >
                                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                                    <div>
                                        <FormControl
                                            {...getInputProps({
                                                placeholder: 'Type the name of your business',
                                            })}
                                        />
                                        <div>
                                            {suggestions.map(suggestion => {
                                                const className = suggestion.active
                                                    ? 'suggestion-item'
                                                    : 'suggestion-item';
                                                const style = suggestion.active
                                                    ? { color: 'black', cursor: 'pointer' }
                                                    : {  color: 'black',cursor: 'pointer' };
                                                return (
                                                    <div
                                                        {...getSuggestionItemProps(suggestion, {
                                                            className,
                                                            style,
                                                        })}
                                                    >
                                                        <span>{suggestion.description}</span>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                        </FormGroup>
                        <FormGroup>
                            <FormGroup className="text-right mt-50">
                                <Button className={classes.Button}
                                        color={'primary'}
                                        variant={'contained'}
                                        onClick={this.onNext}>Next</Button>
                            </FormGroup>
                        </FormGroup>
                    </div>
                </Row>
            </section>
        )
    };
}
const mapStateToProps=(state)=> {
    return {
        events:state.events,
        user:state.loginResponse,
        ownEvents:state.ownEvents,
    }
};

const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        registerAction
    },dispatch)
};

export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(BusinessSection));